package com.ervasstudio.tracoemovimento.util

import kotlin.js.Date

fun formatarDataHoraELocal(incluirHora: Boolean = true): String {
    val agora = Date()
    
    val dia = agora.getDate()
    val ano = agora.getFullYear()
    
    val meses = arrayOf(
        "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
    )
    val mesNome = meses[agora.getMonth()]
    
    val dataTexto = "$dia de $mesNome de $ano"

    return if (incluirHora) {
        val horas = agora.getHours().toString().padStart(2, '0')
        val minutos = agora.getMinutes().toString().padStart(2, '0')
        "$dataTexto às $horas:$minutos"
    } else {
        dataTexto
    }
}